import { render } from "./Epk.vue?vue&type=template&id=2b9c65a8"
import script from "./Epk.vue?vue&type=script&lang=js"
export * from "./Epk.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__